import { Box, Button, Grid, Typography, styled, useTheme } from "@mui/material";

import CoinDrawerList from "components/CoinDrawerList";
import { DefaultUrlWeb } from "config/Configuration";
import { Right } from "assets/Icon";
import { useFormContext } from "react-hook-form";
import { useState } from "react";

export function CoinDrawerSelect({ selectedCoin, coinList, onCoinClick, isTitle = true }) {
  const theme = useTheme();
  const { watch } = useFormContext();
  const isDigital = watch("isDigital");

  const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <Grid item xs={12}>
      {isTitle &&
        <Typography variant="h6" color="text.main">
          Coin
        </Typography>
      }

      <ButtonStyle fullWidth onClick={() => setOpenDrawer(true)}>
        <CoinNameWrapper>
          <img
            src={DefaultUrlWeb + selectedCoin?.imageUrl}
            alt={selectedCoin?.name}
          />

          <Typography component="span" color="text.main">
            {selectedCoin?.name}
          </Typography>
        </CoinNameWrapper>

        <Box display="flex" alignItems="center">
          <Right color={theme.palette.text.main} />
        </Box>
      </ButtonStyle>

      <CoinDrawerList
        onOpen={() => setOpenDrawer(true)}
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
        onCoinClick={onCoinClick}
        coinList={coinList?.lisCoin}
        isDigital={isDigital}
      />
    </Grid>
  );
}

const ButtonStyle = styled(Button)(({ theme }) => ({
  background: theme.palette.modules.input,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderRadius: "8px",

  ":hover": {
    background: theme.palette.modules.input,
  },
}));

const CoinNameWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",

  img: {
    width: "25px",
    height: "25px",
    borderRadius: "50%",
    objectFit: "contain",
    marginRight: theme.spacing(1),
  },
}));

export default CoinDrawerSelect;
